import React from 'react';

import { Box, IconButton, Typography, makeStyles, Theme, createStyles } from '@material-ui/core';
import { FiX } from 'react-icons/fi';

interface Props {
  icon: React.ReactNode;
  title: string;
  text?: string;
  onClose: () => void;
  closeLabel: string;
  closeIcon?: React.ReactNode;
}

// What the next message is about, over the composer: "Reply to Sam",
// "Edit message", "Translated". Telegram's bar with an accent line.
export const ChatComposerBar: React.FC<Props> = ({ icon, title, text, onClose, closeLabel, closeIcon }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>{icon}</Box>
      <Box className={classes.body}>
        <Typography component="span" className={classes.title}>
          {title}
        </Typography>
        {!!text && (
          <Typography component="span" className={classes.text}>
            {text}
          </Typography>
        )}
      </Box>
      <IconButton size="small" onClick={onClose} aria-label={closeLabel} className={classes.close}>
        {closeIcon || <FiX size={18} />}
      </IconButton>
    </Box>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: { display: 'flex', alignItems: 'center', gap: 8, padding: '2px 4px 0 8px' },
    icon: { flex: 'none', display: 'flex', color: theme.palette.primary.main },
    body: {
      flex: 1,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: 8,
      borderLeft: `2px solid ${theme.palette.primary.main}`,
    },
    title: { fontSize: 13, fontWeight: 600, lineHeight: '18px', color: theme.palette.primary.main },
    text: {
      fontSize: 13,
      lineHeight: '18px',
      color: theme.palette.text.secondary,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    close: { flex: 'none', color: theme.palette.text.secondary },
  })
);
